import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { isMobileOrTablet } from '@nx-smartmonkey/shared/helpers';
import { capacitorService } from '../application/CapacitorService';
import { storageService } from '../application/StorageService';
import AppBannerLogo from '../assets/svg/AppBannerLogo';
import CrossIcon from '../assets/svg/CrossIcon';
import Button from '../react-components/Button';
import { Text } from '../react-components/Text';

const APP_BANNER_DISMISSED = `APP_BANNER_DISMISSED`;

const LogoContainer = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: 24px;
  height: 24px;
  background: ${RoutalPalette.primary80};
  box-shadow: 0px 0px 8px 4px rgba(125, 154, 150, 0.15);
`;

const BannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  min-height: 80px;
  background-color: ${RoutalPalette.neutral02};
  padding: 20px;
  z-index: 10000;
`;

export const MobileAppBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState<boolean>(false);

  const fetchShowBanner = async () => {
    const result = await storageService.getItem({ key: APP_BANNER_DISMISSED });
    if (!result) {
      setShowBanner(true); // Show banner if not dismissed
    }
  };

  useEffect(() => {
    // Detect if the component is in the app
    if (capacitorService.isNative()) {
      setShowBanner(false); // Hide banner if in the app
      return;
    }

    if (isMobileOrTablet()) {
      fetchShowBanner();
    }
    // if (/iPad|iPhone|iPod/.test(userAgent)) {
  }, []);

  const handleOpenPlayStore = (): void => {
    const userAgent = navigator.userAgent;

    // If device is Android, open the Play Store
    if (/android/i.test(userAgent)) {
      window.location.href = `https://play.google.com/store/apps/details?id=com.routal.drivers`;
      return;
    }

    // If device is iOS, open the App Store
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href = `https://apps.apple.com/es/app/routal/id6741764694`;
      return;
    }
  };

  // THIS IS AN ASYNC FUNCTION
  const handleCloseBanner = async (): Promise<void> => {
    setShowBanner(false);
    await storageService.setItem({ key: APP_BANNER_DISMISSED, item: `true` });
  };

  return (
    <>
      {showBanner && (
        <BannerContainer>
          <div
            style={{
              position: `absolute`,
              left: `8px`,
            }}
          >
            <CrossIcon
              onClick={handleCloseBanner}
              style={{ color: `${RoutalPalette.secondary60}`, width: `12px`, height: `12px` }}
            />
          </div>
          <HSpacer medium />
          <Grid item>
            <LogoContainer>
              <AppBannerLogo style={{ width: `24px`, height: `24px` }} />
            </LogoContainer>
          </Grid>
          <HSpacer medium />
          <Grid item container direction="column">
            <Text isBold variant="h6" intlId="driver.banner.improve_your_experience" />

            <Text
              variant="body-large"
              style={{
                color: RoutalPalette.secondary00,
              }}
              intlId="driver.banner.description"
            />
          </Grid>
          <HSpacer medium />
          <Grid item>
            <Button
              style={{
                height: `28px`,
                padding: `6px 20px`,
                fontSize: `13px`,
              }}
              onClick={handleOpenPlayStore}
              intlId="driver.banner.open"
            />
          </Grid>
        </BannerContainer>
      )}
    </>
  );
};
